import { removeSpecialCharacters } from "./index";
import { mpstopicfile } from "./guidelines";

// This is to retrieve guideline page name from URL
export const getTocName = (search) => {
  let tocName;
  const params = new URLSearchParams(search);

  if (search.indexOf("bookTitle") > -1) {
    tocName = params.get("bookTitle");
  } else {
    try {
      const guidelinePage = removeSpecialCharacters(
        params.get("guidelinePage"),
      );
      tocName = mpstopicfile[guidelinePage.replace(/ /g, "_")]?.text || " ";
    } catch (error) {
      console.error(error);
    }
  }
  if (tocName && tocName.includes("_")) {
    tocName = tocName.replace(/_+/g, " ").trim().replace(/\s+/g, " ");
  }
  return tocName;
};